// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"162":"77223e45","480":"fe4190a3","522":"27b1b3e4","553":"54db6064","835":"4054f4ad","919":"af402ed3","961":"d036eba5"}[chunkId] + ".css";
};